import { z } from "zod";
import { useHistory, useLocation } from "react-router-dom";
import { useLocationState } from "../../domains/app/hooks/useLocationState";
import { auth } from "../../services/firebase";
import { GPT_LANDING_PATH } from "@juisci/gpt-handoff";

// A fixup transports the destination's state without interpreting its commands.
const navigationPayloadSchema = z
  .object({ initialQuestionOwnerUid: z.string().nullable().default(null) })
  .loose();
export const fixupNavigationStateSchema = navigationPayloadSchema
  .nullable()
  .default(null);
const locationStateSchema = z
  .object({ ownerUid: z.string(), state: navigationPayloadSchema })
  .nullable()
  .default(null);

export function fixupReturnState(
  ownerUid: string,
  state: z.infer<typeof fixupNavigationStateSchema>,
  pathname: string
) {
  if (state === null) return null;
  if (pathname !== GPT_LANDING_PATH && state.initialQuestionOwnerUid === null)
    return null;
  const questionOwnerUid =
    state.initialQuestionOwnerUid === null
      ? ownerUid
      : state.initialQuestionOwnerUid;
  return {
    ownerUid: questionOwnerUid,
    initialQuestionOwnerUid: questionOwnerUid,
    state,
  };
}

export function useFixupReturnTo() {
  const location = useLocation();
  const history = useHistory();
  const state = useLocationState(locationStateSchema);
  const returnTo = new URLSearchParams(location.search).get("returnTo");
  const destination =
    returnTo !== null && returnTo.startsWith("/") && !returnTo.startsWith("//")
      ? returnTo
      : "/";
  return () => {
    if (state === null) {
      history.replace(destination, null);
      return;
    }
    // Check at navigation time, including after an asynchronous confirmation.
    const user = auth.currentUser;
    if (user === null || user.uid !== state.ownerUid) return;
    history.replace(destination, {
      ...state.state,
      initialQuestionOwnerUid: state.ownerUid,
    });
  };
}
